import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { FAQs } from '@cc-shopping/ui/composites/FAQs';
import Grid from '@mui/material/Grid';
import { useRef } from 'react';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import { v4 as uuid } from 'uuid';
import { useReviewContext } from '../../Context';
import { reviewsSectionTitleTypographyProps } from '../../components/SectionTitle';
export default function ReviewFAQs() {
  const {
    faqs,
    slug
  } = useReviewContext();
  const activityId = useRef(uuid());
  const fireExpandCollapsePageAction = usePageAction({
    actionName: 'accordion_item',
    actionSection: 'faqs',
    parentActivityId: activityId.current
  });
  const handleAccordionChange = (index: number, expanded: boolean) => {
    fireExpandCollapsePageAction({
      action_type: expanded ? 'expand' : 'collapse',
      action_input: index.toString()
    });
  };
  if (!faqs || faqs.length === 0) {
    return null;
  }
  return <FeatureViewed entityName="accordion" entitySection="faqs" impressionPosition={9} activityId={activityId.current}>
      <Grid mb={5} size={12}>
        <FAQs faqs={faqs} customTitleProps={{
        ...reviewsSectionTitleTypographyProps,
        marginBottom: 1
      }} onAccordionChange={handleAccordionChange} canonicalPathname={`/credit-cards/reviews/${slug}`} Renderer={StructuredContentRenderer} />
      </Grid>
    </FeatureViewed>;
}